import { PLANE } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyProperties } from './base';

export class Plane extends BaseObject {
  constructor() {
    super(new THREE.PlaneGeometry(PLANE.WIDTH, PLANE.HEIGHT), new THREE.MeshStandardMaterial({ color: PLANE.COLOR }));

    this.width = PLANE.WIDTH;
    this.height = PLANE.HEIGHT;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.PlaneGeometry(this.width, this.height);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      let needsUpdate = false;

      if ('width' in properties && properties.width !== this.width) {
        this.width = Number(properties.width) || 1;
        this.userData.data.width = this.width;
        needsUpdate = true;
      }
      if ('height' in properties && properties.height !== this.height) {
        this.height = Number(properties.height) || 1;
        this.userData.data.height = this.height;
        needsUpdate = true;
      }

      if (needsUpdate) this.updateGeometry();
    };
  }
}
